export class ENoticeRequiredError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ENoticeRequiredError'
  }
}
